import React from "react";
import {
  ListItem,
  ListItemText,
  Tooltip,
  Typography,
  ListItemSecondaryAction,
} from "@material-ui/core";
import exerciseConstants from "constants/Exercises/exerciseConstants";

/**
 * Componente que representa um item individual na lista de exercícios.
 * Exibe o título, autor e uma prévia da descrição através de um Tooltip.
 * * @author Willian
 * @param {Object} props Propriedades do componente.
 * @param {Object} props.ex Objeto contendo os dados do exercício.
 * @param {string} props.language Idioma atual da interface ('pt' ou 'en').
 * @param {Function} props.onClick Função chamada ao clicar no item.
 * @param {JSX.Element} [props.actions] Componentes de ação (ex: botões de editar/excluir).
 * @returns {JSX.Element} O item de lista renderizado.
 */
export default function ExerciseItem({ ex, language, onClick, actions }) {
  const listLabels = exerciseConstants.list;

  // Inicialização de objetos para evitar erros de undefined
  let titleObj = {};
  if (ex.title) {
    titleObj = ex.title;
  }

  let descObj = {};
  if (ex.description) {
    descObj = ex.description;
  }

  // Definição do título baseada no idioma
  let title = "";
  if (titleObj[language]) {
    title = titleObj[language];
  }

  // Definição da descrição com fallback para texto padrão
  let description = "";
  if (descObj[language]) {
    description = descObj[language];
  } else {
    description = listLabels.noDescription[language];
  }

  // Definição do autor
  let authorName = "";
  if (ex.author) {
    authorName = ex.author;
  }

  /**
   * Executa a função de clique passando o objeto do exercício.
   */
  const handleItemClick = () => {
    onClick(ex);
  };

  return (
    <Tooltip title={description} placement="left" arrow>
      <ListItem button onClick={handleItemClick}>
        <ListItemText
          primary={
            <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
              {title}
            </Typography>
          }
          secondary={`${listLabels.author[language]}${authorName}`}
        />
        {actions && (
          <ListItemSecondaryAction>{actions}</ListItemSecondaryAction>
        )}
      </ListItem>
    </Tooltip>
  );
}
